import React from 'react'
import { Text } from 'react-native-elements'
import ModalHeader from './ModalHeader'
import { Overlay } from 'react-native-elements'
import { View, Platform } from 'react-native'
import spacing from '../styles/spacing'

import { ActivityIndicator } from 'react-native-paper'

export const FileImportOverlay = (props) => {
  const smallHeaderStyle = {
    fontSize: 18,
    paddingVertical: 6,
    fontWeight: 'strong'
  }
  return (
    <Overlay
      isVisible={true}
      onBackdropPress={props.onClosePressed}
      overlayStyle={{
        position: 'relative',
        margin: 0,
        padding: 0,
        minWidth: 320,
        maxHeight: '95%'
      }}
    >
      <View style={{ flex: 1 }}>
        <View
          style={{
            flex: 1,
            padding: spacing.m1,
            minHeight: Platform.OS === 'ios' ? 330 : 140
          }}
        >
          <ModalHeader>File Import Details</ModalHeader>

          {props.performingImport && (
            <View
              style={{
                alignContent: 'center',
                alignItems: 'center',
                paddingVertical: 12
              }}
            >
              <ActivityIndicator size="small" />
              <Text style={{ paddingLeft: 12 }}>Performing Import</Text>
              <Text style={smallHeaderStyle}>
                Is Test: {props.testRun ? 'YES' : 'NO'}
              </Text>
            </View>
          )}
        </View>
      </View>
    </Overlay>
  )
}

export default FileImportOverlay
